import { FormEvent, memo, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { UrlHelper } from '@bridebook/web/lib/url-helper';
import { useTranslation } from 'next-i18next';
import { Flex, Icon, IconButton } from '@bridebook/aura';
import { Close, Search } from '@bridebook/aura/src/icons';

const SearchBar = () => {
  const { t } = useTranslation('articles');
  const router = useRouter();
  const searchParam = (router.query.search as string) || '';
  const [search, setSearch] = useState(searchParam);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const searchString = encodeURIComponent(search.trim());
    if (searchString) {
      router.push(`${UrlHelper.advice}?search=${searchString}`);
    }
  };

  useEffect(() => {
    setSearch(searchParam);
  }, [searchParam]);

  return (
    <form onSubmit={handleSubmit}>
      <Flex className="min-w-[276px] items-center rounded-full border-2 border-space-08 transition-[border-color] duration-300 focus-within:border-indigo-crush">
        <Flex className="ml-2 size-8 shrink-0 items-center justify-center rounded-full bg-indigo-crush">
          <Icon icon={Search} size={16} className="text-white" />
        </Flex>
        <input
          name="search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder={t('search.placeholder')}
          className="h-12 min-w-0 grow p-2"
        />
        <div className="mr-2 flex size-8 shrink-0 items-center justify-center">
          {search && (
            <IconButton
              type="button"
              variant="grey"
              size="sm"
              icon={Close}
              className="bg-space-08 text-space"
              onClick={() => setSearch('')}
            />
          )}
        </div>
      </Flex>
    </form>
  );
};

export default memo(SearchBar);
